import { contactReceiptSchema, type ContactMessage } from "@shared/contracts";
import { request } from "../../platform/api/request";

export function sendMessage(message: ContactMessage) {
  return request("/contact", contactReceiptSchema, { method: "POST", body: message });
}
